<template>
    <div ref="target" class="soga">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'MoveTarget',
    mounted() {

        /**
         * 递归查找当前vue实例特殊名字的父容器
         * @param {*} vm vue实例
         * @param {*} name 名字
         * 
         * @returns {Object} 找到了就是vue实例 找不到就是null
         */
        function getVmByName(vm,name) {
            function fresh(parent) {
                if (parent.$options.name === name)
                    return parent
                else
                    return parent.$parent ? fresh(parent.$parent) : null
            }

            return fresh(vm.$parent)
        }

            // 移动组件实例
        let parent = getVmByName(this,'MoveWrap');
        if (!parent) return console.error('MoveWrap not find')

            // 移动组件dom
        let el = parent.$el,
            // 移动组件的父容器
            wrap = el.parentNode,
            // 当前把手组件dom
            header = this.$refs.target;

        header.onmousedown = function(e){      
            e.preventDefault();//清除默认行为
            
            if (e.button != 0) return 

            var wrap_height = wrap.offsetHeight,
                wrap_width = wrap.offsetWidth;

            var startY = e.clientY,
                startX = e.clientX;

            var aboveY = parseFloat(el.style.top || 0),
                aboveX = parseFloat(el.style.left || 0);
                wrap.addEventListener('mousemove',m3,false);
                document.querySelector('iframe').style['pointer-events'] = 'none'
            function m3(e){
                e.preventDefault();//清除默认行为

                let offset_y = e.clientY - startY;
                let offset_x = e.clientX - startX;

                // 不够阈值不触发移动
                if (Math.abs(offset_y) < 5 && Math.abs(offset_x) < 5) return;
                
                var y = aboveY + offset_y,
                    x = aboveX + offset_x;

                if (y < 0) {
                    el.style.top = 0 + 'px';
                }else if(wrap_height - el.offsetHeight >= 0 && y > (wrap_height - el.offsetHeight)) {
                    el.style.top = wrap_height - el.offsetHeight + 'px';
                }else {
                    el.style.top = y + 'px';
                }

                if (x < 0) {
                    el.style.left = 0 + 'px';
                } else if (wrap_width - el.offsetWidth >= 0 && x > (wrap_width - el.offsetWidth)){
                    el.style.left = wrap_width - el.offsetWidth + 'px';
                } else {
                    el.style.left = x + 'px';
                }

            }

            wrap.onmouseleave = function(e){
                wrap.removeEventListener('mousemove',m3,false);
                document.querySelector('iframe').style['pointer-events'] = 'auto'
                e.preventDefault();//清除默认行为

                wrap.onmouseleave = null;
            }

            wrap.onmouseup = function(e){
                wrap.removeEventListener('mousemove',m3,false);
                document.querySelector('iframe').style['pointer-events'] = 'auto'

                e.preventDefault();//清除默认行为

                wrap.onmouseup = null;
            }
        }
    }
}
</script>